import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2de43200"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "notice-content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notice-title"
}, "权限提示", -1));
const _hoisted_3 = ["aria-expanded"];
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'IncomePermissionNotice',
  props: {
    message: null
  },
  setup(__props) {
    const props = __props;
    const textRef = ref(null);
    const expanded = ref(false);
    const canExpand = ref(false);
    let resizeObserver;
    // 按实际渲染高度判断是否超过两行，适配窗口宽度和不同长度的产品 ID。
    const measureOverflow = () => {
      var _textRef$value$scroll, _textRef$value;
      canExpand.value = ((_textRef$value$scroll = (_textRef$value = textRef.value) === null || _textRef$value === void 0 ? void 0 : _textRef$value.scrollHeight) !== null && _textRef$value$scroll !== void 0 ? _textRef$value$scroll : 0) > 41;
    };
    watch(() => props.message, async () => {
      expanded.value = false;
      await nextTick();
      measureOverflow();
    });
    onMounted(() => {
      resizeObserver = new ResizeObserver(measureOverflow);
      if (textRef.value) resizeObserver.observe(textRef.value);
      measureOverflow();
    });
    onBeforeUnmount(() => {
      var _resizeObserver;
      return (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 ? void 0 : _resizeObserver.disconnect();
    });
    return (_ctx, _cache) => {
      const _component_a_alert = _resolveComponent("a-alert");
      return _openBlock(), _createBlock(_component_a_alert, {
        class: "income-permission-notice",
        type: "warning",
        "show-icon": ""
      }, {
        message: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
          ref_key: "textRef",
          ref: textRef,
          class: _normalizeClass(["notice-text", {
            'is-expanded': expanded.value
          }])
        }, _toDisplayString(__props.message), 3), canExpand.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "notice-toggle",
          "aria-expanded": expanded.value,
          onClick: _cache[0] || (_cache[0] = $event => expanded.value = !expanded.value)
        }, _toDisplayString(expanded.value ? '收起' : '展开全部'), 9, _hoisted_3)) : _createCommentVNode("", true)])]),
        _: 1
      });
    };
  }
});